import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { ApplicationEmptyState } from "core/components";
import { PreviewLayout } from "core/layouts";
import { BaasicButton } from "core/components";

function ProductPreviewTemplate({ productPreviewViewStore }) {
    const {
        item,
        loaderStore,
        hasCreatePermission,
        goToEditPage,
        goToProductHistory,
    } = productPreviewViewStore;

    return (
        <PreviewLayout
            store={productPreviewViewStore}
            emptyRenderer={<ApplicationEmptyState />}
            loading={loaderStore.loading}
        >
            <div className="row">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        {/* <div className="u-mar--bottom--med">
                            <div className="card__header">
                                <h3 className="card__header__title">
                                    {item && <React.Fragment>{item.itemId}</React.Fragment>}
                                </h3>
                            </div>                        
                        </div> */}

                        <div className="u-mar--bottom--med">
                            <div className="form__title form__title--preview u-flex--space-between">
                                <h4>
                                    <b>Details</b>
                                </h4>
                                <div className="u-flex--default u-mar--left--auto u-mar--bottom--tny">
                                    <BaasicButton
                                        authorized={hasCreatePermission}
                                        className="btn btn--base btn--primary"
                                        label="Edit"
                                        onClick={() => goToEditPage()}
                                    />
                                    <BaasicButton
                                        className="btn btn--base btn--primary u-mar--left--tny"
                                        label="History"
                                        onClick={() => goToProductHistory()}
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Item Id
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && (
                                                <React.Fragment>
                                                    {item.itemId}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Item Name
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && (
                                                <React.Fragment>
                                                    {item.description}
                                                    {!item.billableToMedicare && <i className="u-icon u-icon--med u u-icon--non-billable u-mar--left--tny" ></i>}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Alternative Name
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.alternativeName}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Item Category
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.itemCategory &&
                                                item.itemCategory.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                SubCategory
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.subCategory &&
                                                item.subCategory.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Procedure Code
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.procedureCode_ &&
                                                item.procedureCode_.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Unit Of Measure
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.unitOfMeasure &&
                                                item.unitOfMeasure.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                MCR Multiplier
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.units}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Quantity Per Case
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.qtyPerCase}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Default Quantity
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.defaultQuantity}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Medicare Allowable
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.mcrallowable}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Units To Send
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.amountOfUnitsToSend}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Cals Per Ml
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.calsPerMl}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Cals Per Container
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.caloriesPerContainer}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Mls Per Container
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.mlsPerContainer}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Container Size
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.containerSize}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Container Type
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.itemType &&
                                                item.itemType.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Inner Cannula
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.innerCannula &&
                                                item.innerCannula.itemId}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Product Type
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.defaultItemType &&
                                                item.defaultItemType.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                             <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Product Tags
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.productProductTags && item.productProductTags.length > 0
                                             && item.productProductTags.map((ppt, i) => (
                                                <span  key={ppt.id}>
                                                    {ppt.productTag.name}
                                                    {i < item.productProductTags.length - 1 ? ', ' : ''}
                                                </span>
                                            ))
                                        }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Pump Brand
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.pumpBrand &&
                                                item.pumpBrand.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Specialty Type
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.specialtyType &&
                                                item.specialtyType.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Parent Product
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.parentProduct &&
                                                item.parentProduct.itemId}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Vendor
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item &&
                                                item.vendor &&
                                                item.vendor.name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                SAPs
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isSAPs ? (
                                                <i className="u-icon u-icon--sml u-icon--active"></i>
                                            ) : (
                                                <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Billable To Medicare
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.billableToMedicare ? (
                                                <i className="u-icon u-icon--sml u-icon--active"></i>
                                            ) : (
                                                <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Is Preferred
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.isPreferred ? (
                                                <i className="u-icon u-icon--sml u-icon--active"></i>
                                            ) : (
                                                <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Discontinued
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && !item.isActive ? (
                                                <i className="u-icon u-icon--sml u-icon--active"></i>
                                            ) : (
                                                <i className="u-icon u-icon--sml u-icon--inactive"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Backordered
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.backordered && (
                                                <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Notes
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.notes}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Height
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.heightDescription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Width
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.widthDescription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">
                                                Wound Care Item Subcategory
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && item.woundCareItemSubCategoryDescription}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PreviewLayout>
    );
}

ProductPreviewTemplate.propTypes = {
    productPreviewViewStore: PropTypes.object,
    t: PropTypes.func,
};

export default defaultTemplate(ProductPreviewTemplate);
